export default __webpack_public_path__ + "static/media/ic_twoPerson.f4554168.svg";